import { FVFunil } from '../fvfunil';
import { CRMContato } from './crmcontato';
import { CRM } from './crmfunil';
import { CRMOportunidadeAtributo } from './crmoportunidade-atributo';
import { CRMTag } from './crmtag';
import { Cliente } from '../../models/cliente';

export class CRMOportunidade {
  id: number;
  idCRM: number;
  crm: CRM;
  titulo: string;
  idCanal: number;
  valorEstimado: number;
  dtExpectativa: Date;
  idEtapa: number;
  etapaNome: string;
  idUsuario: number;
  dtAbertura: Date;
  status: number;
  dtStatus: Date;
  idResposta?: number;

  contato: CRMContato;
  idContato: number;
  contatoNome: string;
  contatoUf: string;
  contatoCidade: string;

  cliente: Cliente;
  idCliente: number;
  clienteNome: string;
  clienteUf: string;
  clienteCidade: string;

  dataUltimaAtividade: Date;
  dataPrimeiraAtividadeAtrasada: Date;
  clienteCelular: string;
  checado: boolean;
  statusUltimaAtividade: number;
  assinado: boolean;
  tags: CRMTag[];
  potencia: number;
  consumo: number;
  numInstalacaoUC: string;
  transferirAtividades: boolean;
  atributos: CRMOportunidadeAtributo[] = [];

  idVendedor?: number;

  todasAtividadesConcluidas: boolean
}
